import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { take } from 'rxjs';

import { AbstractComponent } from '../../../components/cms/abstract-component.component';
import { ShoppableContentInterface, SkeeperShoppableContentInterface } from '../../../models';
import { WrapperComponent } from '../../../components/static/core';
import {
  SkeeperShoppableContentComponent
} from '@seb/web-common/core/components/static/skeeper-shoppable-content/skeeper-shoppable-content.component';

@Component({
  selector: 'wc-shoppable-content',
  templateUrl: './shoppable-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WrapperComponent,
    SkeeperShoppableContentComponent
  ]
})
export class ShoppableContentComponent extends AbstractComponent<ShoppableContentInterface> implements OnInit {
  data: SkeeperShoppableContentInterface;
  hasVideos = true;

  constructor(
    private readonly cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$
        .pipe(take(1))
        .subscribe((cmp: ShoppableContentInterface) => {
          this.data = {
            title: cmp?.title,
            product: cmp?.product,
            collection: cmp?.collection
          };
          this.setLoaded();
          this.cdRef.detectChanges();
        })
    );
  }

  checkHasVideos(event) {
    this.hasVideos = event;
    this.cdRef.detectChanges();
  }
}
